import { Fragment, useCallback, useEffect, useState } from 'react'
import Pagination from 'components/Pagination/Pagination';
import Table from 'components/Table/Table';
import TableSkeleton from 'components/Table/TableSkeleton/TableSkeleton';
import { selectAuthUser } from 'features/auth/authSlice';
import { useDeleteCallCenterAgentsMutation, useGetCallCenterAgentsQuery } from 'features/call_center/callCenterApiSlice';
import { setNavbarTitle } from 'features/navbar/navbarSlice';
import toast from 'react-hot-toast';
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useSearchParams } from 'react-router-dom';

import cardStyles from "styles/modules/Card.module.scss";
import { actions } from 'utils/helpers';
import { UNAUTHORIZED } from 'constants';

const CallCenterAgents = ({ label }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [searchParams] = useSearchParams();
  const [errorDisplayed, setErrorDisplayed] = useState(false);

  const {
    currentData,
    isFetching: isLoading,
    isError,
    error
  } = useGetCallCenterAgentsQuery(searchParams.toString());

  const [deleteCallCenterAgent] = useDeleteCallCenterAgentsMutation();

  const authUser = useSelector(selectAuthUser);

  useEffect(() => {
    dispatch(setNavbarTitle("Call Center Agents"));
  }, [dispatch]);

  // useEffect(() => {
  //   console.log("Current Data in Component:", currentData);
  // }, [currentData]);


  useEffect(() => {
    if (isError && !errorDisplayed) {
      toast.error(error?.message || "Could not load call center agents, try refreshing the page");
      setErrorDisplayed(true);
    }
  }, [isError, error, errorDisplayed]);

  const onItemClickHandler = (id) => {
    navigate(`/call_center/agent/${id}`);
  };

  const onDeleteBtnHandler = useCallback(
    async (id, callFn = false) => {
      if (authUser?.actions[label].includes(actions.delete)) {
        if (callFn) {
          await deleteCallCenterAgent(id).unwrap();
        }
        return "";
      }
      return UNAUTHORIZED;
    },
    [authUser?.actions, deleteCallCenterAgent, label]
  );

  return (
    <div>
      <div className={cardStyles.menu}>
        <h3>Showing data for call center agents</h3>
      </div>
      {isLoading ? (
        <TableSkeleton />
      ) : (
        <Fragment>
          <Table
            data={currentData}
            onItemClickHandler={onItemClickHandler}
            onDelete={onDeleteBtnHandler}
          />
          <Pagination totalCount={currentData?.size} />
        </Fragment>
      )}
    </div>
  )
}

export default CallCenterAgents